export class VehicleService {
  constructor(
    private readonly apiUrl: string,
  ) {}

  async getAllVehicles() {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/gestionnaire/vehicules`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error("Erreur lors de la récupération des véhicules:", error);
      throw error;
    }
  }

  async createVehicle(idEntreprise: number, vehicle: any) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}/vehicule`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(vehicle),
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la création du véhicule:", error);
      throw error;
    }
  }

  async updateVehicle(idEntreprise: number, idVehicle: number, vehicle: any) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}/vehicule/${idVehicle}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(vehicle),
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour du véhicule:", error);
      throw error;
    }
  }

  async deleteVehicle(idEntreprise: number, idVehicle: number) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}/vehicule/${idVehicle}`,
        {
          method: "DELETE",
          headers: {
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la suppression du véhicule:", error);
      throw error;
    }
  }

  async addDocumentVehicle(
    entrepriseId: number,
    idVehicle: number,
    documentFormData: FormData,
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${entrepriseId}/vehicule/${idVehicle}/document`,
        {
          method: "POST",
          headers: {
          },
          body: documentFormData,
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout du document au véhicule:", error);
      throw error;
    }
  }

  async loadDocumentFile(
    idVehicle: number,
    entrepriseId: number,
    documentId: number,
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${entrepriseId}/vehicule/${idVehicle}/document/${documentId}`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.blob();
    } catch (error) {
      console.error("Erreur lors de la récupération du document:", error);
      throw error;
    }
  }

  async deleteDocumentVehicle(
    idVehicle: number,
    entrepriseId: number,
    documentId: number,
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${entrepriseId}/vehicule/${idVehicle}/document/${documentId}`,
        {
          method: "DELETE",
          headers: {
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la suppression du document du véhicule':",
        error,
      );
      throw error;
    }
  }

  async loadLicenceFile(
    idVehicle: number,
    entrepriseId: number,
    documentId: number,
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${entrepriseId}/vehicule/${idVehicle}/licence/${documentId}`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.blob();
    } catch (error) {
      console.error("Erreur lors de la récupération de la licence:", error);
      throw error;
    }
  }

  async addLicenceVehicle(
    entrepriseId: number,
    idVehicle: number,
    documentFormData: FormData,
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${entrepriseId}/vehicule/${idVehicle}/licence`,
        {
          method: "POST",
          headers: {
          },
          body: documentFormData,
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout du document au véhicule:", error);
      throw error;
    }
  }

  async deleteLicenceVehicle(
    idVehicle: number,
    entrepriseId: number,
    licenceId: number,
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${entrepriseId}/vehicule/${idVehicle}/licence/${licenceId}`,
        {
          method: "DELETE",
          headers: {
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la suppression de la licence du véhicule':",
        error,
      );
      throw error;
    }
  }
}
